import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';

const TextBox = ({
  name,
  hint,
  defaultValue,
  value,
  onChange,
  placeholder,
  maxLength
}) => {
  const textboxRef = useRef(null);
  return (
    <div className="text-box">
      <input
        ref={textboxRef}
        className="text-box_input"
        defaultValue={defaultValue}
        type="text"
        value={value}
        name={name}
        onChange={e => {
          onChange(e.target.value);
        }}
        placeholder={placeholder}
        maxLength={maxLength}
      />
      <span className="text-box_hint">
        {hint || `${value ? value.length : 0}/${maxLength}`}
      </span>
    </div>
  );
};

TextBox.propTypes = {
  name: PropTypes.string,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.string,
  value: PropTypes.string,
  hint: PropTypes.string,
  maxLength: PropTypes.number,
  onChange: PropTypes.func
};

TextBox.defaultProps = {
  onChange: () => {},
  maxLength: 20
};

export default TextBox;
